import styled from "styled-components";
import * as React from "react";
import {StyledBaseProps} from "@betrue/common-front";
import {FileUploadProps} from "./fileupload";
import Dropzone from "react-dropzone";
import {Grid, Paper} from "@mui/material";

interface FileUploadViewProps extends StyledBaseProps, FileUploadProps {
  dropZoneLabel?: string
  accept?: string
  onDrop: (file) => void
}

export const FileUploadView = styled((props: FileUploadViewProps) => {


  return (
    <div className={props.className}>
      <Dropzone
        onDrop={props.onDrop}
        accept={[props.accept || 'image/*']}
      >
        {({getRootProps, getInputProps}) => (
          <Paper elevation={1} className={'bt-drop-zone'}>
            <Grid container style={{height: '100%'}}   justifyContent={'center'}
                  alignItems={'center'}>
              <Grid item xs={12} alignItems={'center'} alignContent={'center'}>
                <div {...getRootProps()}>
                  <p>{props.dropZoneLabel ? props.dropZoneLabel : 'Déposer Votre fichier ou cliquer ici'}</p>
                  <input {...getInputProps()} />
                </div>
              </Grid>
            </Grid>
          </Paper>
        )}
      </Dropzone>
    </div>)
})`
  & {

    height: ${(props) => props.height || '200px'};
    margin: 10px;

    .bt-drop-zone:hover {
      border-color: ${props => props.theme.palette.primary.main};
      color: ${props => props.theme.palette.primary.main};
      cursor: pointer;
    }

    .bt-drop-zone {
      flex: 1;
      width: ${(props) => props.width || '100%'};
      height: ${(props) => props.height || '200px'} !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-width: 2px;
      border-radius: 2px;
      border-color: #eeeeee;
      border-style: dashed;
      background-color: #fafafa;
      outline: none;

      transition: border .24s ease-in-out;
    }
  }

`
